import { Box, Heading, HStack, Stack } from "@chakra-ui/react";
import { Dispatch, FC, SetStateAction, useEffect } from "react";
import { Control, FieldValues, UseFormWatch } from "react-hook-form";
import { borderRadius, borderStyle } from "../../../../utils/styles/styles";
import FormSelect from "../../../../components/molecule/Select/FormSelect";
import { getPartners } from "../../../../services/TabelasAuxiliares/getPartner";
import { WarningIcon } from "@chakra-ui/icons";
import { getCollectionFrequency } from "../../../../services/Indicator/getCollectionFrequency";
import { Auxiliares } from "../../../../types/TabelasAuxiliares/Auxiliares";
import { getDataPeriod } from "../../../../services/Indicator/getDataPeriod";
import { getIndicatorData } from "../../../../services/Indicator/getIndicatorData";
import DatePickerComponent from "../../../../components/molecule/DatePicker/DatePickerComponent";
import { Dayjs } from "dayjs";
import { useAuth } from "../../../../provider/AuthProvider";

interface UploadDataFormProps {
  errors: any;
  control: Control<any>;
  watch: UseFormWatch<FieldValues>;
  hasWarning: boolean;
  setHasWarning: Dispatch<SetStateAction<boolean>>;
  frequencyOption: Auxiliares;
  selectedYear: Dayjs | null;
  setSelectedYear: Dispatch<SetStateAction<Dayjs | null>>;
}

const UploadDataForm: FC<UploadDataFormProps> = ({
  errors,
  control,
  watch,
  hasWarning,
  setHasWarning,
  frequencyOption,
  selectedYear,
  setSelectedYear,
}) => {
  const { auth } = useAuth();
  const user = auth.user;

  const selectedFrequencyOption = watch("frequencyOption");
  const selectedFrequencyData = watch("frequencyData");
  const selectedPartner = watch("partnerOption");

  useEffect(() => {
    if (
      (selectedYear && selectedFrequencyData) ||
      (selectedYear && selectedFrequencyOption?.id === 6)
    ) {
      setHasWarning(false);
      const fetchData = async () => {
        getIndicatorData(
          selectedFrequencyData?.id,
          selectedYear?.year(),
          selectedPartner?.id,
          selectedFrequencyOption?.id,
        )
          .then((result) => {
            result.length !== 0 && setHasWarning(true);
          })
          .catch((error) => {
            console.log("API Error:", error);
          });
      };
      fetchData();
    }

    if (!selectedFrequencyData || !selectedYear) {
      setHasWarning(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedFrequencyData,
    selectedYear,
    selectedFrequencyOption,
    selectedPartner,
  ]);

  return (
    <Stack
      spacing={4}
      border={borderStyle}
      borderRadius={borderRadius}
      background="gray.50"
      p={6}
    >
      <Heading as="h3" fontSize="2xl">
        Informações
      </Heading>
      <FormSelect
        control={control}
        errors={errors}
        watch={watch}
        fieldName="partnerOption"
        fieldLabel="Parceiro"
        fetchOptions={getPartners}
        isDisabled={user?.role?.level?.id === 2 && user?.partner}
        defaultValue={
          user?.role?.level !== undefined &&
          user?.role.level.id === 2 &&
          user?.partner !== undefined
            ? user.partner
            : ""
        }
      />
      <FormSelect
        control={control}
        errors={errors}
        watch={watch}
        fieldName="frequencyOption"
        fieldLabel="Frequência de recolha dos indicadores a carregar"
        fetchOptions={getCollectionFrequency}
      />
      <HStack spacing="2">
        <Heading as="h3" fontSize="2xl">
          Período de carregamento
        </Heading>
        {hasWarning && <WarningIcon color="orange.500" boxSize="5" />}
      </HStack>
      <Box width="fit-content">
        <DatePickerComponent
          label="Estou a carregar dados do ano:"
          fieldName="year"
          selectedDate={selectedYear}
          onChange={(date: Dayjs | null) => {
            setSelectedYear(date);
          }}
          mode="year"
          format="YYYY"
          errors={errors}
          isRequired
          control={control}
        />
      </Box>

      {frequencyOption && frequencyOption.id !== 6 && (
        <FormSelect
          control={control}
          errors={errors}
          watch={watch}
          fieldName="frequencyData"
          fieldLabel={`Estou a carregar dados ${frequencyOption.name}:`}
          fetchOptions={() => getDataPeriod(frequencyOption.id)}
          dependencyWatchField="frequencyOption"
          dependencyCondition={(selectedFrequencyOption) =>
            !!selectedFrequencyOption
          }
          isRequiredCondition={() => selectedFrequencyOption?.id !== 6}
        />
      )}
    </Stack>
  );
};

export default UploadDataForm;
